export default "__VITE_ASSET__BMcxT4pM__"